<template>
    <div class="popup-wrapper"  v-show="show.isShow">
        <transition>
            <div class="masker" @click="close"></div>
        </transition>
        
        <transition name="fade" mode="out-in" appear>
            <div class="popup-wrap">
                <div class="pop-head" v-show="title" v-html="title"></div>
                <div class="pop-body">
                    <slot></slot>
                </div>
                <div class="pop-foot">
                    <a v-for="button in buttons" href="javascript:;" class="tn-btn" :class="`tn-btn_${button.type}`" @click="onClick(button.onClick, button.close)" v-text="button.text" :key="button.text"></a>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
export default {
    name: 'popup',
    data () {
        return {
            scrollTop: 0
        }
    },
    props: {
        show: {
            type: Object,
            default: {
                isShow: false
            }
        },
        title: {
            type: String,
            default: ''
        },
        buttons: {
            type: Array,
            default () {
                let self = this;
                return [{
                    type: 'cancel',
                    text: '关闭',
                    onClick: function() {
                        self.close();
                    }
                }];
            }

        }
    },
    methods: {
        onClick (handler, close) {
            let handlerResult = typeof handler === 'function' && handler();
            if (handlerResult === false) {
                return;
            }
            this.close();
        },
        close () {
            this.show.isShow = false;
        },
        toggleClass (el, className, flag) {
            if (flag) {
                if(!~el.className.indexOf(className)) {
                    el.className += ` ${className}`;
                }
            } else {
                if(~el.className.indexOf(className)) {
                    el.className = el.className.replace(className, '')
                }
            }
        }
    },
    watch: {
        'show.isShow' (val) {
            if (typeof window !== 'undefined') {
                let html = document.querySelector("html");
                let body =  document.body;
                let PAGE_FIXED = 'pageFixed';
                this.toggleClass(html, PAGE_FIXED, val);
                this.toggleClass(body, PAGE_FIXED, val);
            }
        }
    }
};
</script>

<style lang="scss">
// .popup-wrapper {
//     position: fixed;
//     top: 0;
//     right: 0;
//     left: 0;
//     bottom: 0;
//     z-index: 99;
// }

.popup-wrap {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 101;
    background: #fff;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    .pop-head {
        padding: 18px 0;
        text-align: center;
        font-size: 18px;
        line-height: 22px;
        font-weight: 700;
        color: #051b28;
    }
}

.masker {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 100;
    touch-action: manipulation;
}
.pop-body {
    padding-bottom: 20px;
}
.pop-foot {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    flex-wrap: nowrap;
    a {
        flex-grow: 1;
        height: 44px;
        margin: 8px 18px;
        line-height: 44px;
        color: #fff;
        font-size: 16px;
        text-align: center;
        background: #32c45d;
        border-radius: 22px;
        touch-action: manipulation;
    }
}

.fade-enter-active,
.fade-leave-active,
.fade-transition {
    transition: opacity .25s ease;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.fade-enter-to,
.fade-leave {
    opacity: 1;
}

.slide-bottom-enter-active, .slide-bottom-leave-active {
    transition: transform .25s ease-in;
}
.slide-bottom-enter, .slide-bottom-leave-to {
    transform: translateY(110%);
}
.slide-bottom-enter-to, .slide-bottom-leave {
    transform: translateY(0);
}
.point-radio{
    position: relative;
    padding-top: 24px;
}
.point-right-text{ 
    font-size: 14px;
    color: #777893;
    padding-left: 18px;
}
.radioBtn{
    position: absolute;
    right: 18px;
}
.discountMoney{ 
    position: absolute;
    right: 51px;
    top: 22px;
    font-style: normal;
    font-size: 14px;
    color: #ff6436;
}
</style>




// WEBPACK FOOTER //
// Popup.vue